import { Components } from "appworks/components/components";
import { FadeIn, FadeOut } from "appworks/graphics/animation/base-animations";
import { gameState } from "appworks/model/game-state";
import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Services } from "appworks/services/services";
import { State } from "appworks/state-machine/states/state";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { Sequence } from "appworks/utils/contracts/sequence";
import { DMFInstantWinsComponent } from "components/dmf-instant-wins-component";
import { TGRSymbolComponent } from "components/tgr-symbol";
import { gameLayers } from "game-layers";
import { TGRInstantWin, TGRInstantWinResult } from "integration/builders/results/tgr-instant-win-result";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";
import { TGRSoundEvent } from "tgr-sound-event-enum";

const COLLECT_DURATION: number = 800;
const WIN_DURATION: number = 1000;
const STAGGER: number = 300;
const TOTAL_WIN_SHOW_TIME: number = 1000;

export class DMFShowInstantWins extends State {

    public onEnter(): void {
        super.onEnter();

        const gameplay: Gameplay = gameState.getCurrentGame();
        const instantWinResult: TGRInstantWinResult = gameplay.getCurrentRecord().getResultsOfType(TGRInstantWinResult)[0];
        const collectSymbol: TGRSymbolComponent = Components.get(MatrixComponent).getSymbol(
            instantWinResult.collectSymbolPosition.x,
            instantWinResult.collectSymbolPosition.y
        ) as TGRSymbolComponent;

        const collectContracts: Array<() => Contract<void>> = [];
        instantWinResult.instantWins.forEach((instantWin: TGRInstantWin, i: number) => {
            const delay: number = STAGGER * i;
            collectContracts.push(
                () => Contract.getDelayedContract(delay, () =>  Components.get(DMFInstantWinsComponent).animateCollect(instantWinResult, instantWin, COLLECT_DURATION))
            );
        });

        const winContracts: Array<() => Contract<void>> = [];
        let cumulativeWin: number = 0;
        const wins: number[] = [];
        instantWinResult.instantWins.forEach((instantWin: TGRInstantWin, i: number) => {
            const delay: number = COLLECT_DURATION + (STAGGER * i);
            wins.push(cumulativeWin += instantWin.cashWon);
            winContracts.push(
                () => Contract.getDelayedContract(delay, () =>  Components.get(DMFInstantWinsComponent).animateWin(instantWin, WIN_DURATION)),
                () => Contract.getDelayedContract(delay + WIN_DURATION,
                    () => Contract.wrap(() => Components.get(DMFInstantWinsComponent).setTopValue(Services.currency.format(wins[i]), 350))
                )
            );
        });

        new Sequence([
            () => new Parallel([
                () => Contract.wrap(() => Services.sound.customEvent(TGRSoundEvent.monkeysymbol_animate)),
                () => collectSymbol.win()
            ]),
            () => new Parallel([
                () => gameLayers.InstantWins.setScene("instant_win"),
                () => FadeOut(gameLayers.TigerHeader.getSprite("logo"), 350)
            ]),
            () => new Parallel([
                ...collectContracts,
                ...winContracts
            ]),
            () => Contract.getDelayedContract(TOTAL_WIN_SHOW_TIME, () => new Parallel([
                () => gameLayers.InstantWins.defaultScene(),
                () => FadeIn(gameLayers.TigerHeader.getSprite("logo"), 350)
            ]))
        ]).then(() => this.complete());
    }
}
